
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      tab_selected: this.tab_active,
    };
  },

  props: {
    tab_active: {
      type: Number,
      required: false,
      default: 0,
    },
    tab_names: {
      type: Array,
      required: true,
    },
  },

  methods: {
    onClick(index: number): void {
      this.tab_selected = index;
      this.$emit('changed', index);
    },
  },
});
